module.exports = __webpack_public_path__ + "static/media/background.cd47afbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/background.jpg
// module id = 78
// module chunks = 0